// extracted by mini-css-extract-plugin
module.exports = {"progress":"styles_progress__1lKgq","progressContent":"styles_progressContent__3Y3HK"};